<template>
    <div class="ma-4">
        <ClientNav/>
        <v-row dense>
            <v-col cols="12">
                <v-spacer></v-spacer>
                <v-card>
                    <v-card-title style="background-color: #2b3990">
                        <span class="headline white--text">{{ titleForm }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-form ref="form">
                                <v-row>
                                    <v-col cols="12" sm="12">
                                        <v-menu
                                            ref="menu"
                                            v-model="menu"
                                            :close-on-content-click="false"
                                            :return-value.sync="date"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="auto"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="newDate"
                                                    label="Date"
                                                    prepend-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="newDate"
                                                no-title
                                                scrollable
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="menu = false"
                                                >
                                                    Cancel
                                                </v-btn>
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="$refs.menu.save(date)"
                                                >
                                                    OK
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <v-textarea
                                            v-model="newDescription"
                                            label="Warning Description"
                                            :rules="requiredRules"
                                            outlined
                                        ></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            fab
                            small
                            @click="showPrintModal()"
                            class="mr-8 mb-2 white--text"
                            color="#2b6993"
                            elevation="4"
                            v-if="!createWarning"
                        >
                            <v-icon>print</v-icon>
                        </v-btn>
                        <v-btn
                            class="white--text"
                            color="#259647"
                            @click="addWarning()"
                            v-if="createWarning"
                        >Save
                        </v-btn
                        >
                        <v-btn
                            color="blue darken-1 white--text"
                            @click="updateWarning()"
                            v-if="!createWarning">
                            Update
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="close">
                            Cancel
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <Foot/>
    </div>
</template>

<script>
import axios from "axios";
import ClientNav from "../../../components/ClientNav";
import Foot from "../../../components/Footer";
import {displaySuccess, displayError} from "../../../service/notification-message.service";
import PrintUtil from "../../../../utils/print-util";
// import moment from 'moment'

const url = require("../../../client_config/config").url;

export default {
    components: {
        ClientNav,
        Foot,
    },
    data() {
        return {
            date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                .toISOString()
                .substr(0, 10),
            menu: false,
            msg: false,
            search: "",
            text: "",
            warnings: [],
            warning: {},
            users: [],
            clientID: this.$route.params.clientID,
            warningId: this.$route.params.id,
            userID: localStorage.getItem("userID"),
            token: localStorage.getItem('token'),
            tempData: [],
            titleForm: "New Client Warning",
            warningID: "",
            newDate: "",
            newDescription: "",
            editedIndex: -1,
            editedItem: {
                date: "",
                description: "",
            },
            defaultItem: {
                date: "",
                description: "",
            },
            isLoading: true,
            requiredRules: [(v) => !!v || "This is required"],
            createWarning: false,
        };
    },

    computed: {},

    watch: {},

    created() {
        this.createWarning = this.$route.query.createWarning === 'true'
        this.getWarnings();
    },

    mounted() {
        if (!this.createWarning) {
            this.getWarning();
        }

        window.addEventListener('keydown', async (event) => {
            this.downloadUrl = await this.generateDownloadUrl();
            PrintUtil.handleKeydown(event, this.downloadUrl, this.warningId, this.token, 'Warning');
        });
    },

    beforeDestroy() {
        window.removeEventListener('keydown', (event) => {
            PrintUtil.handleKeydown(event, this.downloadUrl, this.warningId, this.token, 'Warning');
        });
    },

    methods: {
        initialize() {
            this.warnings = [];
        },

        validate() {
            return this.$refs.form.validate();
        },

        viewWarning(item) {
            this.titleForm = "Viewing Warning";
            this.newDate = item.Date;
            this.newDescription = item.Description;
            this.warningID = item._id;
        },

        close() {
            this.newDate = "";
            this.newDescription = "";
            this.$router.go(-1);
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },

        async updateWarning() {
            if (this.validate) {
                let req_body = {
                    Date: this.newDate,
                    Description: this.newDescription,
                };
                try {
                    const response = await axios.put(`${url}/warning/${this.warningId}`, req_body);
                    if (response.status !== 200) {
                        displayError("An error occurred updating the warning. Please try again.");
                        return;
                    }
                    displaySuccess("The warning has been updated successfully.");
                    this.getWarnings();
                } catch (error) {
                    displayError("An error occurred. Please try again.");
                } finally {
                    this.close();
                }
            } else {
                displayError("Please fill in all the required fields.");
            }
        },

        getWarnings() {
            this.isLoading = true;
            axios
                .get(`${url}/warning`)
                .then((res) => {
                    this.warnings = [];
                    this.tempData = res.data.warnings;
                    for (var i = 0; i < this.tempData.length; i++) {
                        if (this.tempData[i].ClientID === this.clientID) {
                            this.warnings.push(this.tempData[i]);
                        }
                    }
                })
                .finally(() => (this.isLoading = false));
        },

        getUsers() {
            axios.get(`${url}/users`).then(async (res) => {
                this.users = res.data.users;
            });
        },

        async addWarning() {
            if (this.validate()) {
                let req_body = {
                    Date: this.newDate,
                    Description: this.newDescription,
                    ClientID: this.clientID,  // Assuming ClientID comes from route parameters as mentioned
                };

                try {
                    const response = await axios.post(`${url}/warning`, req_body);
                    if (response.status !== 200) {
                        displayError("An error occurred while adding the warning.");
                    }
                    displaySuccess("The warning has been added successfully.");
                    this.getWarnings();
                } catch (error) {
                    displayError(error.message || "An error occurred.");
                } finally {
                    this.close();
                }
            } else {
                displayError("Please fill in all the required fields."); // This should only show if validation fails
            }
        },


        getWarning() {
            axios.get(`${url}/warning/${this.warningId}`).then((res) => {
                this.warning = res.data.warning;
                this.viewWarning(this.warning);
            });
        },

        async generateDownloadUrl() {
            return `${url}/warning/print?id=${this.warningId}`;
        },

        async showPrintModal() {
            this.downloadUrl = await this.generateDownloadUrl();
            PrintUtil.showPrintOption(this.downloadUrl, this.warningId, this.token,'Warning');
        },
    },
};
</script>
<style>
@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }
}
</style>
